module.exports = __webpack_public_path__ + "static/media/UserManualPM.950196ce.pdf";